import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import _size from 'lodash/size';
import { FaSpinner } from 'react-icons/fa';

import socioSchemaValidacoes from './SocioSchemaValidacoes';
import isRequiredField from '~/Utils/isRequiredField';

import FormDadosPessoais from '../../ProspectoDetalhes/FormDadosPessoais';
import { salvarSocio, getAtualizarCidades } from '~/Store/Prospecto/actions';
import { nullPropertiesToString } from '~/Utils/Helpers';
import { toast } from 'react-toastify';

const ModalAdicionarProspecto = ({
  permitidoAdicionarDocumento,
  options,
  salvarSocio,
  salvandoSocio,
  erroSalvarSocio,
  prospecto,
  onClose,
  showModal,
  socio = null,
}) => {
  const { detail: prospectoRedux } = useSelector(state => state.prospecto);

  const obterVinculoEmpreendimento = codigoFamilia => {
    if (
      !prospecto ||
      !prospecto.prospecto_empreendimento ||
      prospecto.prospecto_empreendimento.length === 0
    ) {
      return null;
    }

    const codigoFamiliaBusca = codigoFamilia || prospecto.codigo_familia;

    const vinculoSelecionado = codigoFamiliaBusca
      ? prospecto.prospecto_empreendimento.find(
          item => Number(item.codigo_familia) === Number(codigoFamiliaBusca)
        )
      : null;

    if (vinculoSelecionado) {
      return vinculoSelecionado;
    }

    return prospecto.prospecto_empreendimento.find(
      item => Number(item.codigo_corretor) > 0 && Number(item.codigo_gerente) > 0
    );
  };

  const valorIdentificador = (valor, fallback) => {
    if (Number(valor) > 0) {
      return valor;
    }

    return fallback;
  };

  const vinculoEmpreendimentoAtual = obterVinculoEmpreendimento();

  let initialValues = {
    codigo_prospecto_cliente: prospecto.codigo,
    codigo_grupo_empresa: vinculoEmpreendimentoAtual
      ? valorIdentificador(
          vinculoEmpreendimentoAtual.codigo_grupo_empresa,
          prospecto.codigo_grupo_empresa
        )
      : prospecto.codigo_grupo_empresa,
    codigo_conta: vinculoEmpreendimentoAtual
      ? valorIdentificador(
          vinculoEmpreendimentoAtual.codigo_conta,
          prospecto.codigo_conta
        )
      : prospecto.codigo_conta,
    codigo_familia: vinculoEmpreendimentoAtual
      ? vinculoEmpreendimentoAtual.codigo_familia
      : prospecto.codigo_familia,
    codigo_corretor: vinculoEmpreendimentoAtual
      ? valorIdentificador(
          vinculoEmpreendimentoAtual.codigo_corretor,
          prospecto.codigo_corretor
        )
      : prospecto.codigo_corretor,
    codigo_gerente: vinculoEmpreendimentoAtual
      ? valorIdentificador(
          vinculoEmpreendimentoAtual.codigo_gerente,
          prospecto.codigo_gerente
        )
      : prospecto.codigo_gerente,
    codigo_nacionalidade: 1,
    tipo_pessoa: 0,
    tipo: '',
    nome: '',
    cpf: '',
    email: '',
    tel_celular: '',
    tel_residencial: '',
    tel_comercial: '',
    estado_civil: prospecto.estado_civil,
    sexo: '',
    rg: '',
    data_emissao_rg: '',
    cnh: '',
    orgao_emissor_cnh: '',
    nascimento: '',
    codigo_status: '',
    cep: prospecto.cep,
    estado: prospecto.estado,
    bairro: prospecto.bairro,
    endereco: prospecto.endereco,
    numero: prospecto.numero,
    complemento: prospecto.complemento,
    cidade: prospecto.cidade,
    codigo_cidade: prospecto.codigo_cidade,
    orgao_emissor_rg: '',
    data_casamento: '',
    registro_antenupcial: '',
    tabeliao: '',
    prospecto_titular_estado_civil: prospectoRedux.estado_civil,
    prospecto_titular_tipo_pessoa: prospectoRedux.tipo_pessoa,
    prospecto_titular_cpf: prospectoRedux.cpf,
  };

  if (socio) {
    let socioEditar = prospecto.ConjugePorEmpreendimento.find(
      item => item.codigo === socio
    );
    socioEditar = socioEditar || {};
    const vinculoSocio = obterVinculoEmpreendimento(socioEditar.codigo_familia);
    //Sobrescreve o objeto para renderizar o modal
    initialValues = { ...initialValues, ...socioEditar };

    if (vinculoSocio) {
      initialValues = {
        ...initialValues,
        codigo_grupo_empresa: valorIdentificador(
          vinculoSocio.codigo_grupo_empresa,
          initialValues.codigo_grupo_empresa
        ),
        codigo_conta: valorIdentificador(
          vinculoSocio.codigo_conta,
          initialValues.codigo_conta
        ),
        codigo_familia: vinculoSocio.codigo_familia,
        codigo_corretor: valorIdentificador(
          vinculoSocio.codigo_corretor,
          initialValues.codigo_corretor
        ),
        codigo_gerente: valorIdentificador(
          vinculoSocio.codigo_gerente,
          initialValues.codigo_gerente
        ),
      };
    }

    initialValues = nullPropertiesToString(initialValues);
  }
  const erroSalvarSocioRedux = useSelector(
    state => state.prospecto.salvandoSocio.erro
  );

  useEffect(() => {
    if (erroSalvarSocioRedux) {
      toast.error(erroSalvarSocioRedux);
    }
  }, [erroSalvarSocioRedux]);

  const salvarConjugeSocio = values => {
    if (!values.codigo_corretor || Number(values.codigo_corretor) === 0) {
      toast.error(
        'Não foi possível identificar o corretor responsável pelo empreendimento.'
      );
      return;
    }

    if (!values.codigo_gerente || Number(values.codigo_gerente) === 0) {
      toast.error(
        'Não foi possível identificar o gerente responsável pelo empreendimento.'
      );
      return;
    }

    salvarSocio(values);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={salvarConjugeSocio}
      validationSchema={socioSchemaValidacoes}
    >
      {({ errors, touched, handleSubmit, submitCount, ...formikProps }) => {
        return (
          <Modal
            size="lg"
            show={showModal && permitidoAdicionarDocumento}
            onHide={onClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {socio ? 'Editar' : 'Novo'} Cônjuge/Sócio
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormDadosPessoais
                permitidoAdicionarDocumento={permitidoAdicionarDocumento}
                formProspecto={{
                  ...formikProps,
                  errors,
                  touched,
                  handleSubmit,
                }}
                onCancel={onClose}
                isRequiredField={field =>
                  isRequiredField(field, socioSchemaValidacoes)
                }
                isSubmitting={salvandoSocio}
                getAtualizarCidades={getAtualizarCidades}
                options={options}
              />
              {submitCount > 0 && _size(errors) > 0 && (
                <div className="FormDadosPessoais__error text-danger">
                  Preenchas os campos corretamente antes de salvar
                </div>
              )}
              {erroSalvarSocio && (
                <div className="FormDadosPessoais__error text-danger">
                  Não foi possível salvar os dados do cônjuge/sócio. Confira os
                  valores inseridos, como nome, CPF/CNPJ ou outros campos
                  obrigatórios, e tente novamente.
                </div>
              )}
              <div className="d-flex d-sm-block text-right justify-content-between">
                <Button
                  variant="link"
                  className="text-uppercase px-4 d-block d-sm-inline-block"
                  onClick={onClose}
                  disabled={salvandoSocio}
                >
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  onClick={handleSubmit}
                  className="text-uppercase px-4 d-block d-sm-inline-block"
                  disabled={salvandoSocio}
                >
                  {salvandoSocio ? (
                    <>
                      <FaSpinner /> Salvando...
                    </>
                  ) : (
                    'Salvar'
                  )}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => ({
  permitidoAdicionarDocumento:
    state.prospecto.detail.permitidoAdicionarDocumento,
  options: state.options,
  salvandoSocio: state.prospecto.salvandoSocio.salvando,
  erroSalvarSocio: state.prospecto.erroSalvarSocio,
  prospecto: state.prospecto.detail,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      salvarSocio,
      getAtualizarCidades,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ModalAdicionarProspecto)
);
